import React from "react";
import { Skeleton } from "@mui/material";

const DetailsViewItemSkeleton: React.FC = () => {
  return <Skeleton width="100%" height="24px" />;
};

export default DetailsViewItemSkeleton;
